/* CLARESS · Kit landing — toggle de audiencia + carrito + WhatsApp + scroll reveal. Sin dependencias. */
(() => {
  document.querySelectorAll('.ckl').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    let config = {};
    try { config = JSON.parse(root.querySelector('[data-ckl-config]')?.textContent || '{}'); } catch (_) {}
    let items = [];
    try { items = JSON.parse(root.querySelector('[data-ckl-items]')?.textContent || '[]'); } catch (_) {}

    const setAudience = (aud) => {
      root.querySelectorAll('[data-audience-btn]').forEach((b) => b.classList.toggle('is-active', b.dataset.audienceBtn === aud));
      root.querySelectorAll('[data-audience-text]').forEach((el) => { el.hidden = el.dataset.audienceText !== aud; });
    };
    root.querySelectorAll('[data-audience-btn]').forEach((btn) => {
      btn.addEventListener('click', () => setAudience(btn.dataset.audienceBtn));
    });

    const whatsappUrl = () => {
      const lines = [
        `Hola CLARESS 🩷 Quiero pedir la ${config.kitName || 'rutina'}.`,
        '',
        ...items.map((it) => `• ${it.name}`),
        '',
        `¿Me confirman disponibilidad y cómo pago? Vi el ${config.discountPercent ? config.discountPercent + '% off' : 'descuento'} en la página.`
      ];
      return `https://wa.me/${String(config.whatsapp || '').replace(/\D/g, '')}?text=${encodeURIComponent(lines.join('\n'))}`;
    };
    root.querySelectorAll('[data-action="whatsapp"]').forEach((a) => { a.href = whatsappUrl(); });

    root.querySelectorAll('[data-action="add-cart"]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const usable = items.filter((it) => it.variantId);
        if (!usable.length) { window.location.href = whatsappUrl(); return; }
        btn.disabled = true;
        const label = btn.textContent;
        btn.textContent = 'Agregando…';
        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: usable.map((it) => ({ id: Number(it.variantId), quantity: 1 })) })
          });
          if (!res.ok) throw new Error('cart_add_failed');
          const dest = config.discountCode
            ? `${config.cartUrl || `${rootPath}cart`}?discount=${encodeURIComponent(config.discountCode)}`
            : (config.cartUrl || `${rootPath}cart`);
          window.location.assign(dest);
        } catch (_) {
          btn.disabled = false;
          btn.textContent = label;
          window.location.href = whatsappUrl();
        }
      });
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      root.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
    } else {
      root.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
    }
  });
})();
